import React from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import axios from "axios";
import { IDENTITY_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const SocialAuthButtons = ({ onGoogleSuccess }) => {
  const handleLoginSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential; // JWT from Google

    console.log("Google success", credentialResponse);
    
    try {
      const { data } = await apiClient.post(
        `${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/google/admin`,
        { idToken }
      );
      onGoogleSuccess?.({ ...data, idToken });
    } catch (err) {
      console.error(err);
      if (err.response) {
        // Server responded with a status outside 2xx
        console.error("Server error:", err.response.data);
        toast.error(err.response.data.message || "Login failed");
      } else if (err.request) {
        // Request made but no response
        console.error("No response received:", err.request);
        toast.error("No response from server, please try again later");
      } else {
        // Something else went wrong
        console.error("Error setting up request:", err.message);
        toast.error("Login error: " + err.message);
      }
    }
  };

  return (
    <Form.Group className="mb-0 mt-4">
      <Row className="g-3">
        <Col
          sm={12}
          className="pe-sm-1 d-flex align-items-center justify-content-center"
        >
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={() => {
              console.log("Login Failed");
            }}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};

export default SocialAuthButtons;
